import { PDFDocument, rgb, StandardFonts } from "pdf-lib";

export const generatePdf = async (data) => {
    const existingPdfBytes = await fetch("/MODELO3.pdf").then(res =>
        res.arrayBuffer()
    );

    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const pages = pdfDoc.getPages();
    const page = pages[0];
    const { height } = page.getSize();

    const hoje = new Date();

    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

    const dataPorExtenso = hoje.toLocaleDateString('pt-BR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });

    const draw = (text, x, y) => {
        page.drawText(String(text || ""), {
            x,
            y: height - y,
            size: 11,
            color: rgb(0, 0, 0),
        });
    };

    function formatHora(hora) {
        if (!hora) return "";
        return hora.slice(0, 5); // Pega só HH:MM
    }   

    const formatDate = (dateString) => {
        if (!dateString) return "";
        return new Date(dateString).toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            timeZone: 'UTC'
        });
    };

    function wrapText(text, font, fontSize, maxWidth) {
        const words = text.split(' ');
        const lines = [];
        let line = '';

        for (const word of words) {
            const testLine = line + (line ? ' ' : '') + word;
            const width = font.widthOfTextAtSize(testLine, fontSize);
            if (width < maxWidth) {
                line = testLine;
            } else {
                lines.push(line);
                line = word;
            }
        }
        if (line) lines.push(line);
        return lines;
    }


    let valortotal = 0.00;

    let valor = 0;

    if (data.valor_orcado) {
        valor = parseFloat(data.valor_orcado);
    } else {
        valor = parseFloat(data.valorOrcado);
    }

    let sinal = valor * 0.1;
    let sinalFormat = 0.00;

    sinalFormat = sinal.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    valortotal = valor.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const fontSize = 11;

    const text = "O sinal de 10% (R$ " + (sinalFormat) + ") deverá ser dado até " +
        formatDate(data.data_sinal) + ", e o pagamento deverá ser realizado até " +
        formatDate(data.data_pagamento) + ", por transferência bancária ou Pix, conforme os dados abaixo:";

    const linhas = wrapText(text, font, fontSize, 500);

    let y = 458;
    for (const linha of linhas) {
        page.drawText(linha, {
            x: 56,
            y: height - y,
            size: fontSize,
            font,
            color: rgb(0, 0, 0),
        });
        y += fontSize + 4;
    }

    draw(("empresa " + data.cliente_nome + ", com data de saída prevista para " + formatDate(data.data_inicio) + "."), 56, 252);
    
    draw(data.origem, 103, 287.5);
    draw(data.destino, 105, 301.5);
    draw(formatDate(data.data_inicio), 137, 314.5);
    draw(formatDate(data.data_fim), 147, 328.5);
    draw(formatHora(data.horario_saida), 150, 342.5);
    draw(formatHora(data.horario_retorno), 160, 357);
    draw(dataPorExtenso + ".", 111, 605);

    draw("R$ " + valortotal, 170, 428);

    if (data.pagador_pouso === "esportiva") {
        draw("(X) Pago pela Esportiva ( ) Pago pelo Cliente ", 200, 371);
    } else if (data.pagador_pouso === "cliente") {
        draw("( ) Pago pela Esportiva (X) Pago pelo Cliente ", 200, 371);
    }

    if (data.pagador_alimentacao === "esportiva") {
        draw("(X) Pago pela Esportiva ( ) Pago pelo Cliente ", 200, 385);
    } else if (data.pagador_alimentacao === "cliente") {
        draw("( ) Pago pela Esportiva (X) Pago pelo Cliente ", 200, 385);
    }

    if (data.pagador_estacionamento === "esportiva") {
        draw("(X) Pago pela Esportiva ( ) Pago pelo Cliente ", 200, 399);
    } else if (data.pagador_estacionamento === "cliente") {
        draw("( ) Pago pela Esportiva (X) Pago pelo Cliente ", 200, 399);
    }

    draw(("Valido até " + formatDate(data.data_pagamento)), 430, 725);

    const pdfBytes = await pdfDoc.save();
    return new Blob([pdfBytes], { type: "application/pdf" });
};
